import { createFileRoute, redirect } from '@tanstack/react-router'

/** S-04 opens on Summary. */
export const Route = createFileRoute('/_authed/clinics/$clinicId/')({
  beforeLoad: ({ params }) => {
    redirect({
      to: '/clinics/$clinicId/$tab',
      params: { clinicId: params.clinicId, tab: 'summary' },
      replace: true,
      throw: true,
    })
  },
})
